import React, { useState } from "react";
import { useStyles } from "./styles";
import PaymentTabs from "./PaymentTabs";
import CreatePayments from "./CreatePayments";
import PaymentList from "./PaymentList";

const Payments = (props) => {
  const classes = useStyles();
  const {
    unpaidTransactions,
    showSnackBar,
    successMessage,
    errorMessage,
    total,
    has_next,
    fetchAllUnpaidTransactions,
    fetchTdsps,
    closeSnackbar,
    isProcessing,
    tdsps,
    createPayment,
    transactions,
    fetchAllMeterTransactions,
    fetchMeterTransactionTypes,
    setSelectedTransaction,
    location,
  } = props;

  const [selectedView, setSelectedView] = useState("Payments");
  return (
    <div className={classes.root}>
      <h1 id="page-title">
        820 Payments
      </h1>
      <PaymentTabs
        setSelectedView={setSelectedView}
      >
        <PaymentList
          selectedView={selectedView}
          transactions={transactions}
          showSnackBar={showSnackBar}
          successMessage={successMessage}
          errorMessage={errorMessage}
          total={total}
          has_next={has_next}
          fetchAllMeterTransactions={fetchAllMeterTransactions}
          fetchMeterTransactionTypes={fetchMeterTransactionTypes}
          closeSnackbar={closeSnackbar}
          setSelectedTransaction={setSelectedTransaction}
          isProcessing={isProcessing}
          location={location}
          tdsps={tdsps}
          fetchTdsps={fetchTdsps}
        />
        <CreatePayments
          unpaidTransactions={unpaidTransactions}
          showSnackBar={showSnackBar}
          successMessage={successMessage}
          errorMessage={errorMessage}
          total={total}
          has_next={has_next}
          fetchAllUnpaidTransactions={fetchAllUnpaidTransactions}
          fetchTdsps={fetchTdsps}
          closeSnackbar={closeSnackbar}
          isProcessing={isProcessing}
          tdsps={tdsps}
          createPayment={createPayment}
        />
      </PaymentTabs>
    </div>
  );
};

export default Payments;
